<script setup lang="ts">
    import TagsList from '@shared/components/Tags/TagsList.vue';
    import { formatNumericText } from '@shared/utils/formatNumericText';
    import type { List } from './ListsTypes.d';
    import { formatDateTime } from '@cwd/Shared/utils/formatDateTime';
    import { Tag } from '@shared/components/Tags/TagsTypes';

    defineProps<{
        item: List;
        selectedTagIds: string[];
    }>();

    const emit = defineEmits<{
        toggleTag: [tag: Tag];
    }>();
</script>

<template>
    <div class="flex-1" style="min-width: min(400px, 100%)">
        <h2 class="h4 item-heading">
            <router-link :to="{ name: 'List', params: { listId: item.ListId } }">{{ item.Name || $Resources.NoNamePlaceholder }}</router-link>

            <small v-if="item.ScheduledImportsCount > 0" class="m-xs-l">
                <span class="glyphicon glyphicon-circle-arrow-down m-xxs-r c-primary"></span>
                {{ $Resources.ListsViewListHasScheduledImportsLabel }} ({{ item.ScheduledImportsCount }})
            </small>

            <small v-if="item.FailedImportsCount > 0" class="m-xs-l">
                <span class="glyphicon glyphicon-ban-circle m-xxs-r c-danger"></span>
                {{ $Resources.ListsViewListHasFailedImportsLabel }} ({{ item.FailedImportsCount }})
            </small>
        </h2>

        <TagsList v-if="item.Tags.length > 0" :tags="item.Tags" :selectedIds="selectedTagIds" @toggleTag="emit('toggleTag', $event)" />

        <p v-if="item.Description">{{ item.Description }}</p>

        <p class="meta">
            <span class="glyphicon glyphicon-time"></span>
            {{ $Resources.GenericCreatedLabel }} {{ formatDateTime(item.Created) }} {{ $Resources.GenericByLabel }} {{ item.CreatedBy.Name }}

            <i class="fa fa-pencil" aria-hidden="true"></i>
            {{ $Resources.LastModifiedLabel }} {{ formatDateTime(item.LastModified) }} {{ $Resources.GenericByLabel }} {{ item.ModifiedBy.Name }}
        </p>
    </div>

    <div class="ug-bars align-self-center flex-1" style="max-width: 120px">
        <div class="bar-label text-nowrap">
            {{ $Resources.ListContactCountLabel }}
            <span>
                {{ formatNumericText(item.ContactCount, { largeNumbers: true }) }}
            </span>
        </div>
    </div>

    <div v-if="item.ActiveImportsCount > 0" class="w-full text-center">
        {{ $Resources.ImportActiveLabel }}
        <span class="busy-working is-busy m-xs-t" aria-hidden="true"></span>
    </div>
</template>
